export const curStateRightWeb = state => state.reducerRightWeb
export const curStateHome = state => state.reducerHome
export const curStateAccount = state => state.reducerAccount
export const curStateResult = state => state.reducerResult
export const curStateEvent = state => state.reducerEvent
export const curStateEventNewYear2024 = state => state.reducerEventNewYear2024
export const curStateEventThingyan2025 = state => state.reducerEventThingYan
export const curStateMiniGame = state => state.reducerMiniGame
// Cờ Master toàn cục (suy từ rank login-streak) cho mọi trang dùng chung.
export const curIsMaster = state => state.reducerLoginStreakStatus.isMaster
export const curLoginStreakStatus = state => state.reducerLoginStreakStatus
export const curShweVaultStatus = state => state.reducerShweVaultStatus
export const curNotifications = state => state.reducerNotifications
export const curRank = state => state.reducerRankStatus
export const curLoyaltyPoint = state => state.reducerLoyaltyPoint
export const curDailyPrize = state => state.reducerDailyPrizeStatus 
